<template>
  <div>
    <dynamic-list
      model="quotation"
      @update:selectedData="onDataSelected"
    />
    <dynamic-form
      model="quotation"
      :data="selectedQuotation"
      @refresh="fetchData"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import DynamicList from './DynamicList.vue';
import DynamicForm from './DynamicForm.vue';

const selectedQuotation = ref(null);

const onDataSelected = (data) => {
  selectedQuotation.value = data;
};

const fetchData = () => {
  console.log('데이터 새로고침!');
};
</script>
